module.exports = __webpack_public_path__ + "static/media/8OLA16.f9e73c6c.jpg";